import { COMMON_HTTP_MESSAGES, STATUS_CODES } from '../../constants/Http';
import { featureTypes, singularTypeToPlural } from '../../constants/types';
import captureException from '../../utils/captureException';
import { isApiHasMorePages } from '../../utils/general';
import { generatePropertiesDetailsBody } from '../../utils/properties';
import { GET_EXTERNAL_OPTIONS_FAILED, GET_EXTERNAL_OPTIONS_FULFILLED, GET_EXTERNAL_OPTIONS_REFRESH, GET_EXTERNAL_OPTIONS_START, SET_IS_PROPERTIES_LOADING, SET_MENTION_OWNERS, SET_PROPERTIES, START_VALIDATE_PROPERTY, VALIDATE_PROPERTY_FAILED, VALIDATE_PROPERTY_FULFILLED } from './reducer';
export const validatePropertyBeforeEdit = ({
  dispatch,
  apiWrapper
}, {
  crmObjectType,
  data
}) => {
  dispatch({
    type: START_VALIDATE_PROPERTY,
    payload: data
  });
  apiWrapper.validateProperty({
    crmObjectType,
    data
  }).then(response => {
    dispatch({
      type: VALIDATE_PROPERTY_FULFILLED,
      payload: response
    });
  }).catch(error => {
    dispatch({
      type: VALIDATE_PROPERTY_FAILED,
      payload: error
    });
    captureException(error);
  });
};
export const getExternalOptions = ({
  dispatch,
  apiWrapper
}, options) => {
  const entity = options.externalOptions[options.referenceType];

  // don`t need to check isApiHasMorePages if user enter something in input
  // in this case we don`t care about pages, we try to find data according user input
  if (!options.delay && entity && !isApiHasMorePages({
    hasMore: entity.hasMore,
    offset: entity.offset ? +entity.offset : undefined,
    currentOffset: options.offset
  })) {
    dispatch({
      type: GET_EXTERNAL_OPTIONS_REFRESH,
      payload: options
    });
    return;
  }
  dispatch({
    type: GET_EXTERNAL_OPTIONS_START,
    payload: options
  });
  apiWrapper.fetchExternalOptions(options).then(response => {
    if (options.referenceType === 'OWNER' && !options.mentionOwners.length) {
      const parsedOwners = response.results.map(owner => ({
        value: +owner.id,
        searchText: `${owner.label} (${owner.description})`,
        dropdownText: `${owner.label} (${owner.description})`,
        text: owner.label,
        userId: owner.additionalFields.activeUserId
      }));
      dispatch({
        type: SET_MENTION_OWNERS,
        payload: parsedOwners
      });
    }
    dispatch({
      type: GET_EXTERNAL_OPTIONS_FULFILLED,
      payload: {
        options,
        data: response
      }
    });
  }).catch(error => {
    if (error.status === STATUS_CODES.NETWORKERROR && error.message && error.message.includes(COMMON_HTTP_MESSAGES.REQUEST_ABORTED)) return;
    dispatch({
      type: GET_EXTERNAL_OPTIONS_FAILED,
      payload: options
    });
    captureException(error);
  });
};
export const getProperties = ({
  dispatch,
  apiWrapper
}, {
  featuresStatus,
  objectType,
  errorCallback
}) => {
  dispatch({
    type: SET_IS_PROPERTIES_LOADING,
    payload: true
  });
  const isFeatureAvailable = () => {
    // mean that we check feature status in upper component
    if (!featuresStatus) return true;
    if (featuresStatus) {
      const featureKey = featureTypes[singularTypeToPlural[objectType]];
      const feature = featuresStatus[featureKey];
      if (feature) return feature.available;
      return false;
    }
    return false;
  };
  if (isFeatureAvailable()) {
    apiWrapper.fetchCardProperties({
      objectType
    }).then(propertiesResponse => {
      const propertiesDetailsBody = generatePropertiesDetailsBody(propertiesResponse);
      return apiWrapper.fetchPropertiesDetails({
        objectType,
        data: propertiesDetailsBody
      }).then(({
        results: propertiesDetails
      }) => {
        dispatch({
          type: SET_PROPERTIES,
          payload: {
            data: Object.assign({
              objectType,
              propertiesDetails
            }, propertiesResponse),
            objectType
          }
        });
      }).catch(captureException);
    }).catch(err => {
      captureException(err);
      if (typeof errorCallback === 'function') errorCallback();
    }).finally(() => {
      dispatch({
        type: SET_IS_PROPERTIES_LOADING,
        payload: false
      });
    });
  }
};